export const environment = {
  produccion: false,

  // APIs Agenda
  apiEndPointDev: import.meta.env.NG_APP_API_DEV,
  apiEndPointTest: import.meta.env.NG_APP_API_TEST,
  apiEndPointDemo: import.meta.env.NG_APP_API_DEMO,
  apiEndPointProd: import.meta.env.NG_APP_API_PROD,

  // APIs Integration
  apiIntegrationsDev: import.meta.env.NG_APP_API_INTEGRATION_DEV,
  apiIntegrationsTest: import.meta.env.NG_APP_API_INTEGRATION_TEST,
  apiIntegrationsDemo: import.meta.env.NG_APP_API_INTEGRATION_DEMO,
  apiIntegrationsProd: import.meta.env.NG_APP_API_INTEGRATION_PROD,

  // MercadoPago
  mercadoPagoKey: import.meta.env.NG_APP_MERCADOPAGOKEY,

  // reCAPTCHA
  recaptchaSiteKey: import.meta.env.NG_APP_RECAPTCHA_SITE_KEY,

  version: '1',

  listClients: {
    dev: 'BDConnectionDev',
    test: 'BDConnectionTest',
    demo: 'BDConnectionDemo',
    prod: 'BDConnectionProd',
    def: null
  },

  // Keys API Agenda
  agendaKeys: {
    dev: import.meta.env.NG_APP_KEY_AGENDA_DEV,
    test: import.meta.env.NG_APP_KEY_AGENDA_TEST,
    demo: import.meta.env.NG_APP_KEY_AGENDA_DEMO,
    prod: import.meta.env.NG_APP_KEY_AGENDA_PROD
  },

  // Keys API Integration
  integrationKeys: {
    dev: import.meta.env.NG_APP_KEY_INTEGRATION_DEV,
    test: import.meta.env.NG_APP_KEY_INTEGRATION_TEST,
    demo: import.meta.env.NG_APP_KEY_INTEGRATION_DEMO,
    prod: import.meta.env.NG_APP_KEY_INTEGRATION_PROD
  }
};
